const logotext = "HATIM";

const meta = {
  title: "Hatim Eddinani | CTO & Tech Founder",
  description:
    "CTO and Tech Founder specializing in AI-driven SaaS, scalable backend systems, and product engineering leadership. Building high-impact technology at OvrtiLabs Tech Systems.",
};


const introdata = {
    title: "Halo! I’m Hatim",
    animated: {
      first: "CTO & Tech Founder",
      second: "Building AI-Powered SaaS Platforms",
      third: "Designing Scalable Backend Systems",
    },
    description:
      "I am a CTO and full-stack engineer focused on building scalable, API-first, AI-driven products. I lead technical strategy, architecture, and execution for startups and growing businesses, translating complex ideas into reliable, production-ready systems.",
    my_img_url: "https://i.ibb.co/JRWXDhyx/DSC-3833.jpg",
  };  

  const dataabout = {
    title: "About Me",
    aboutme:
      "I’m Hatim Eddinani — a CTO, tech founder, and systems thinker. I specialize in designing and leading the development of scalable software platforms, with a strong focus on backend architecture, AI integration, and product reliability.\n\nAs a founder at OvrtiLabs Tech Systems, I work at the intersection of technology, business strategy, and execution — helping teams move from concept to production with clarity and speed. Outside of work, I explore emerging technologies, build experimental products, and maintain a strong creative balance through music and personal R&D projects.",
  };
  
  const worktimeline = [
    {
      jobtitle: "Founder", 
      where: "OvrtiLabs Tech Systems",
      date: "2022 – Present",
    },
    {
      jobtitle: "Full-Stack Web Engineer (Contract)",
      where: "Vyudu, Inc",
      date: "2024", 
    },
    {
      jobtitle: "Full-Stack Developer (Apprenticeship)",
      where: "Juubix",
      date: "2023",
    },
    {
      jobtitle: "Technical Mentor (Volunteer)",
      where: "Microverse, Inc",
      date: "2021", 
    },
  ];
  

  const skills = [
    { name: "JavaScript / TypeScript", value: 85 },
    { name: "React & Modern Frontend", value: 80 },
    { name: "Backend Architecture", value: 90 },
    { name: "AI & Machine Learning", value: 85 },
    { name: "PostgreSQL & Databases", value: 80 },
    { name: "API Design (REST / GraphQL)", value: 85 },
    { name: "Cloud & Deployment", value: 75 },
  ];
  

  const services = [
    {
      title: "AI & Intelligent Systems Engineering",
      description:
        "Design and implement AI-powered systems, including workflow automation, intelligent decision support, and data-driven product features. Focused on practical, production-ready AI that delivers measurable business value.",
    },
    {
      title: "SaaS Product Development",
      description:
        "End-to-end development of scalable SaaS products — from architecture and MVP execution to growth-ready platforms. Emphasis on performance, security, and maintainability.",
    },
    {
      title: "Fractional CTO & Technical Advisory",
      description:
        "Provide strategic technical leadership for startups and growing teams, including architecture decisions, team structuring, roadmap planning, and technology risk management.",
    },
    {
      title: "Custom Systems & Platform Architecture",
      description:
        "Build tailored software systems and internal platforms designed to solve complex operational challenges, integrate seamlessly with existing tools, and scale with the business.",
    },
    {
      title: "Backend Engineering, APIs & Integrations",
      description:
        "Develop robust backend services, APIs, and integrations using modern stacks, enabling high availability, secure data flows, and extensible system design.",
    },
    {
      title: "Codebase Refactoring & Technical Debt Reduction",
      description:
        "Audit, refactor, and modernize existing codebases to improve performance, reliability, and developer velocity, while reducing long-term maintenance and scaling risks.",
    },
  ];
  

const dataportfolio = [
    {
        img: "/projects-images/HiredIQ.png",
        desctiption: "HiredIQ is an AI-powered hiring platform that streamlines the recruitment process with intelligent candidate matching, automated screening, and data-driven insights for better hiring decisions.",
        link: "https://hirediq.ai/",
        slug: "hirediq",
    },
    {
        img: "/projects-images/ovrtdocs.png",
        desctiption: "Ovrtdocs is a modern document management and collaboration platform designed to help teams organize, share, and work together on documents seamlessly.",
        link: "https://www.ovrtdocs.com/",
        slug: "ovrtdocs",
    },
    {
        img: "/projects-images/juubix.png",
        desctiption: "JUUBIX is a Fintech distributed multi-cloud based omni-channel platform offering a SaaS AI matching tool for startups, expertise and finance.",
        link: "https://juubix.com/",
        slug: "juubix",
    },
];

// Case Studies Data - keyed by slug for easy lookup
const caseStudies = {
  "hirediq": {
    meta: {
      title: "HiredIQ - AI-Powered Hiring Platform",
      description: "Building an intelligent recruitment platform that leverages AI to transform how companies find and hire top talent.",
      slug: "hirediq",
      publishedDate: "2025-01-15",
      coverImage: "/projects-images/HiredIQ.png",
    },
    client: { name: "HiredIQ", industry: "HR Tech / AI", url: "https://hirediq.ai/" },
    role: "CTO & Technical Lead",
    timeline: "2024 — Present",
    challenge: "The hiring process is often time-consuming and prone to bias. HiredIQ was built to address these challenges by creating an AI-driven platform that automates candidate screening, provides intelligent matching, and delivers data-driven hiring insights.",
    goals: [
      "Develop AI algorithms for intelligent candidate-job matching",
      "Build a scalable platform capable of handling high-volume recruitment",
      "Create an intuitive interface for recruiters and hiring managers",
      "Implement bias-reduction mechanisms in the screening process",
      "Ensure enterprise-grade security and compliance"
    ],
    process: [
      { step: "Research & Discovery", body: "Conducted extensive research on recruitment pain points, interviewing HR professionals and analyzing existing solutions in the market." },
      { step: "AI Model Development", body: "Designed and trained machine learning models for resume parsing, skill extraction, and candidate-job matching algorithms." },
      { step: "Platform Architecture", body: "Built a microservices architecture with scalable APIs, real-time processing capabilities, and secure data handling." },
      { step: "Product Launch", body: "Iteratively launched features based on user feedback, continuously improving the matching accuracy and user experience." }
    ],
    solutions: [
      "Custom NLP models for intelligent resume parsing and skill extraction",
      "ML-powered matching engine with configurable scoring weights",
      "Real-time candidate ranking and recommendation system",
      "Automated screening workflows with human-in-the-loop validation",
      "Analytics dashboard for hiring insights and funnel optimization"
    ],
    metrics: [
      { label: "Time-to-Hire", value: "-40%", note: "Reduction vs. traditional methods" },
      { label: "Matching Accuracy", value: "92%", note: "Based on hiring outcomes" },
      { label: "Candidates Processed", value: "50K+", note: "Monthly throughput" }
    ],
    testimonials: [],
    gallery: [],
  },
  "ovrtdocs": {
    meta: {
      title: "Ovrtdocs - Document Management Platform",
      description: "A modern document management and collaboration platform built for teams that need seamless organization and real-time collaboration.",
      slug: "ovrtdocs",
      publishedDate: "2024-06-01",
      coverImage: "/projects-images/ovrtdocs.png",
    },
    client: { name: "OvrtiLabs Tech Systems", industry: "SaaS / Productivity", url: "https://www.ovrtdocs.com/" },
    role: "Founder & Lead Developer",
    timeline: "2024 — Present",
    challenge: "Teams often struggle with document sprawl, version control issues, and collaboration bottlenecks. Ovrtdocs was created to provide a unified platform for document management that emphasizes simplicity, collaboration, and powerful organization features.",
    goals: [
      "Build an intuitive document management system with powerful search",
      "Enable real-time collaboration with version history",
      "Create flexible organization with folders, tags, and workspaces",
      "Implement robust access controls and sharing capabilities",
      "Ensure fast performance with large document libraries"
    ],
    process: [
      { step: "User Research", body: "Analyzed workflows of various teams to understand document management needs, pain points, and desired features." },
      { step: "System Design", body: "Architected a scalable backend with efficient document storage, indexing, and real-time sync capabilities." },
      { step: "Frontend Development", body: "Built a responsive, fast UI with React focusing on intuitive navigation and seamless document interactions." },
      { step: "Beta & Iteration", body: "Launched beta with select users, gathered feedback, and iterated on features and performance optimizations." }
    ],
    solutions: [
      "Real-time collaborative editing with conflict resolution",
      "Advanced search with full-text indexing and filters",
      "Flexible workspace and folder organization",
      "Granular permission controls and secure sharing links",
      "Version history with easy restore capabilities"
    ],
    metrics: [
      { label: "Documents Managed", value: "100K+", note: "Across all workspaces" },
      { label: "Search Speed", value: "< 200ms", note: "Full-text search response" },
      { label: "Uptime", value: "99.9%", note: "Platform reliability" }
    ],
    testimonials: [],
    gallery: [],
  },
  "juubix": {
    meta: {
      title: "JUUBIX - Fintech Platform",
      description: "A fintech distributed multi-cloud omni-channel platform offering SaaS AI matching for startups, expertise, and finance.",
      slug: "juubix",
      publishedDate: "2023-12-01",
      coverImage: "/projects-images/juubix.png",
    },
    client: { name: "JUUBIX", industry: "Fintech", url: "https://juubix.com/" },
    role: "Full-Stack Developer (Apprenticeship)",
    timeline: "2023",
    challenge: "Contributed to building a complex fintech platform that connects startups with expertise and financing through AI-powered matching algorithms.",
    goals: [
      "Develop scalable microservices architecture",
      "Implement AI-driven matching algorithms",
      "Build secure multi-tenant SaaS infrastructure",
      "Create intuitive user interfaces for complex workflows"
    ],
    process: [
      { step: "Onboarding", body: "Deep dive into the existing architecture and fintech domain knowledge." },
      { step: "Feature Development", body: "Contributed to core features including user matching and profile systems." },
      { step: "Integration", body: "Worked on third-party integrations and payment processing flows." },
      { step: "Optimization", body: "Improved performance and implemented caching strategies." }
    ],
    solutions: [
      "Microservices architecture for scalability",
      "AI-powered matching engine integration",
      "Secure authentication and authorization",
      "Real-time notifications and updates"
    ],
    metrics: [
      { label: "Platform Status", value: "Live", note: "Production ready" },
      { label: "Architecture", value: "Multi-cloud", note: "Distributed system" },
      { label: "Focus", value: "AI/ML", note: "Matching algorithms" }
    ],
    testimonials: [],
    gallery: [],
  }
};

const contactConfig = {
    YOUR_EMAIL: "hatim@ovrtilabstechsystems.com",
    description: "Interested in collaboration, advisory, or building scalable technology together? Reach out directly and let’s explore how we can create impact.",
    YOUR_SERVICE_ID: "service_qdczscj",
    YOUR_TEMPLATE_ID: "contact_form",
    YOUR_USER_ID: "2y4Z6NV0rG7o7vMi0",
};

const socialprofils = {
    github: "https://github.com/theBwoyProgrammer",
    Instagram: "https://www.instagram.com/the_bwoy_programmer/",
    linkedin: "https://www.linkedin.com/in/hatimdev/",
    twitter: "https://x.com/hatim_xyz", 
    medium: "https://medium.com/@theBwoyPrgrmmr",
  };
  
export {
    meta,
    dataabout,
    dataportfolio,
    caseStudies,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
